import { toast } from "react-toastify";
import { RepositoryFactory } from "repository/RepositoryFactory";

const chatbotKnowledge = RepositoryFactory.get("chatbotKnowledge");

export const getAllKnowledgeArticles =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_CHATBOT_KNOWLEDGE_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.getArticles(params);

      dispatch({
        type: "GET_CHATBOT_KNOWLEDGE",
        payload: {
          articles: Array.isArray(data?.data) ? data.data : [],
          totalPages: data?.totalPages || 1,
          currentPage: data?.currentPage || (params.page || 1),
        },
      });

      dispatch({
        type: "GET_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to load knowledge articles"
      );
      dispatch({
        type: "GET_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });
    }
  };

export const getSingleKnowledgeArticle = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_SINGLE_CHATBOT_KNOWLEDGE_LOADER",
      payload: true,
    });

    const { data } = await chatbotKnowledge.getArticle(id);

    dispatch({
      type: "GET_SINGLE_CHATBOT_KNOWLEDGE",
      payload: data?.data || null,
    });

    dispatch({
      type: "GET_SINGLE_CHATBOT_KNOWLEDGE_LOADER",
      payload: false,
    });
  } catch (err) {
    toast.error(
      err?.response?.data?.message || "Failed to load article details"
    );
    dispatch({
      type: "GET_SINGLE_CHATBOT_KNOWLEDGE_LOADER",
      payload: false,
    });
  }
};

export const clearSingleKnowledgeArticle = () => (dispatch) => {
  dispatch({
    type: "CLEAR_SINGLE_CHATBOT_KNOWLEDGE",
  });
};

export const createKnowledgeArticle =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "SAVE_CHATBOT_KNOWLEDGE_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.createArticle(payload);

      toast.success(data?.message || "Knowledge article created successfully");
      dispatch({
        type: "SAVE_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });

      onSuccess(data?.data);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to create knowledge article"
      );
      dispatch({
        type: "SAVE_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });
    }
  };

export const updateKnowledgeArticle =
  (id, payload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "SAVE_CHATBOT_KNOWLEDGE_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.updateArticle(id, payload);

      toast.success(data?.message || "Knowledge article updated successfully");

      dispatch({
        type: "UPDATE_CHATBOT_KNOWLEDGE_SUCCESS",
        payload: data?.data,
      });

      dispatch({
        type: "SAVE_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });

      onSuccess(data?.data);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to update knowledge article"
      );
      dispatch({
        type: "SAVE_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });
    }
  };

export const deleteKnowledgeArticle =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "DELETE_CHATBOT_KNOWLEDGE_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.deleteArticle(id);

      toast.success(data?.message || "Article deleted successfully");

      dispatch({
        type: "CHATBOT_KNOWLEDGE_DELETED",
        payload: id,
      });

      dispatch({
        type: "DELETE_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });

      onSuccess();
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to delete knowledge article"
      );
      dispatch({
        type: "DELETE_CHATBOT_KNOWLEDGE_LOADER",
        payload: false,
      });
    }
  };

export const getChatbotSettings = () => async (dispatch) => {
  try {
    dispatch({
      type: "GET_CHATBOT_SETTINGS_LOADER",
      payload: true,
    });

    const { data } = await chatbotKnowledge.getSettings();
    const result = data?.data || data?.settings || data || {};

    dispatch({
      type: "GET_CHATBOT_SETTINGS",
      payload: result,
    });

    dispatch({
      type: "GET_CHATBOT_SETTINGS_LOADER",
      payload: false,
    });
  } catch (err) {
    toast.error(
      err?.response?.data?.message || "Failed to load chatbot settings"
    );
    dispatch({
      type: "GET_CHATBOT_SETTINGS_LOADER",
      payload: false,
    });
  }
};

export const updateChatbotSettings =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "SAVE_CHATBOT_SETTINGS_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.updateSettings(payload);

      toast.success(data?.message || "Chatbot settings updated successfully");

      const result =
        data?.data || data?.settings || (data?.adminEmail ? data : payload);

      dispatch({
        type: "GET_CHATBOT_SETTINGS",
        payload: result,
      });

      dispatch({
        type: "SAVE_CHATBOT_SETTINGS_LOADER",
        payload: false,
      });

      onSuccess(result);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to update chatbot settings"
      );
      dispatch({
        type: "SAVE_CHATBOT_SETTINGS_LOADER",
        payload: false,
      });
    }
  };

export const getChatbotFeedbackSummary =
  (days = 30) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_CHATBOT_FEEDBACK_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.getFeedbackSummary({ days });
      const result = data?.data || data || null;

      dispatch({
        type: "GET_CHATBOT_FEEDBACK_SUCCESS",
        payload: result,
      });

      dispatch({
        type: "GET_CHATBOT_FEEDBACK_LOADER",
        payload: false,
      });
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to load chatbot feedback summary"
      );
      dispatch({
        type: "GET_CHATBOT_FEEDBACK_LOADER",
        payload: false,
      });
    }
  };

export const getChatbotAuditLogs =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_CHATBOT_AUDIT_LOADER",
        payload: true,
      });

      const { data } = await chatbotKnowledge.getAuditLogs(params);
      const logs = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];

      dispatch({
        type: "GET_CHATBOT_AUDIT_SUCCESS",
        payload: {
          logs,
          totalPages: data?.totalPages || 1,
          currentPage: data?.currentPage || params.page || 1,
        },
      });

      dispatch({
        type: "GET_CHATBOT_AUDIT_LOADER",
        payload: false,
      });
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to load chatbot audit history"
      );
      dispatch({
        type: "GET_CHATBOT_AUDIT_LOADER",
        payload: false,
      });
    }
  };
